import React from 'react';
import { BottomNavigation, BottomNavigationAction } from '@material-ui/core';
import { Chat } from '@material-ui/icons';
import withStyles from '@material-ui/core/styles/withStyles';
import { styles } from './styles';
import withRoot from '../../withRoot';

interface INorpacBottomNavigationProps {
    classes: any;
    bottomNav: string;
    setBottomNav: Function;
    open: any;
    keyValue: any;
}

const SelectData: React.FC<INorpacBottomNavigationProps> = ({
    classes,
    bottomNav,
    setBottomNav,
    open,
    keyValue
}) => {
    const [value, setValue] = React.useState(0);

    return (
        <div style={{ width: '300px' }}>
            <BottomNavigation
                value={value}
                onChange={(event, newValue) => {
                    setValue(newValue);
                    newValue === keyValue
                        ? setBottomNav(newValue)
                        : setBottomNav(newValue)
                }}
                showLabels
                className={classes.root}
                style={{ overflow: 'scroll', justifyContent: 'unset', height: '75px' }}

            >
                 {open && open.map((data:any)=> (<BottomNavigationAction label={data} icon={<Chat />} />))}
            </BottomNavigation>
        </div>
    );
};

export default withRoot(withStyles(styles)(SelectData));